import { lazyComponent } from '@/utils/lazyComponent'

// 신규(Okta) 회원가입 — /auth/okta-signup
export default lazyComponent(() => import('./OktaSignUp'))
